module.exports = __webpack_public_path__ + "img/pneusDescription.8cfcca82.png";